module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_wayo_studio-d008e64c560e3fcc0b492850f1897b29.webp";